import { Form, Field } from 'redux-form';

import { CheckBox } from 'common/components/forms';

import CreditCardForm from './CreditCardForm';

const AddForm = (props) => {
  const { onSubmit, saveButtonText, isFirstCard } = props;

  const handleCancel = (e) => {
    e.preventDefault();
    props.onCancelFunction();
  };

  const showDefaultCheckbox = () => {
    if (isFirstCard) {
      return null;
    }
    return (
      <Field
        name="isDefault"
        component={CheckBox}
        type="checkbox"
        value="1"
        label="Default Credit Card"
      />
    );
  };

  return (
    <Form onSubmit={onSubmit} className="c7-form" method="post">
      <CreditCardForm />

      {showDefaultCheckbox()}

      <div className="c7-form__button-row">
        <a onClick={handleCancel} className="c7-button-alt">
          Cancel
        </a>
        <button type="submit" className="c7-button">
          {saveButtonText}
        </button>
      </div>
    </Form>
  );
};

export default AddForm;
